import { getFileUrl } from 'api/v2/users';
import type { UseQueryResult } from '@tanstack/react-query';
import useQuery from 'hooks/react-query/useQuery';

import { FilesCacheKeys } from 'types/cacheKeys.types';

const useResolveFileURL = (path: string): UseQueryResult<{ url: string }> =>
  useQuery([FilesCacheKeys.FileURL, { path }], () => getFileUrl(path), {
    enabled: !!path,
  });

export default useResolveFileURL;
